import * as Sentry from '@sentry/nuxt';

const runtimeConfig = useRuntimeConfig();
const GIT_REVISION = runtimeConfig.public.GIT_REVISION;

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    environment: process.env.NODE_ENV,
    release: GIT_REVISION,
    dsn: 'https://00f8be68353f2771360dea5e1bf1bd06@o4507802192117760.ingest.de.sentry.io/4507802212565072',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Tracing
    tracesSampleRate: 1.0,
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      'Unable to preload CSS',
      'Failed to fetch dynamically imported module',
      'The play() request was interrupted',
      'NotAllowedError: play() can only be initiated by a user gesture',
      'Cannot read properties of',
    ],
  });
}
